import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { isEmptyField } from "../../../modules/shared";
import { InitService } from "../../../parsers/init.service";


@Injectable({
  providedIn: 'root'
})
export class ResolverService implements Resolve<any> {
  constructor(private activatedroute:ActivatedRoute, private initSrv: InitService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Observable(observer => {
      let loginConfig:any = route.data;
      const existingConfig = this.initSrv.getConfig(loginConfig.configType);
      if (isEmptyField(existingConfig)) {
        this.initSrv.loadConfig(loginConfig).then(value => {
          observer.next(true);
          observer.complete();
        }, onReject => {
          observer.next(true);
          observer.complete();
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }
}
